import { supabase } from "@/integrations/supabase/client";

export type ImageModerationContext = "profile" | "chat";

export interface ImageModerationResult {
  class: 1 | 2 | 3;
  blocked: boolean;
  unavailable: boolean;
  category?: string;
  reason?: string;
}

const fileToDataUrl = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(reader.error || new Error("Could not read image"));
    reader.readAsDataURL(file);
  });

export async function moderateImageFile(file: File, context: ImageModerationContext): Promise<ImageModerationResult> {
  const imageUrl = await fileToDataUrl(file);
  const { data, error } = await supabase.functions.invoke("moderate-image", {
    body: { imageUrl, context },
  });

  if (error || !data) {
    return { class: 3, blocked: true, unavailable: true, reason: error?.message || "scanner_unavailable" };
  }

  const rawClass = Number((data as any).class ?? 1);
  const cls: 1 | 2 | 3 = rawClass === 3 ? 3 : rawClass === 2 ? 2 : 1;
  const reason = String((data as any).reason || "");
  const unavailable = ["scanner_unavailable", "scanner_error", "exception"].includes(reason);

  return {
    class: cls,
    blocked: unavailable || cls === 3,
    unavailable,
    category: (data as any).category,
    reason,
  };
}